export enum AclTypes {
  aclLockEverything = "aclLockEverything",
  aclAdmin = "aclAdmin",
  aclSuperUser = "aclSuperUser",
  aclIngestPlaceholderCreate = "aclIngestPlaceholderCreate",
  aclIngestConfigCreation = "aclIngestConfigCreation",
  aclIngestWishListView = "aclIngestWishListView",
  aclIngestWishListViewAll = "aclIngestWishListViewAll",
  aclIngestEnableAccessLevelFilter = "aclIngestEnableAccessLevelFilter",
  aclIngestUpload = "aclIngestUpload",
  aclIngestMonitor = "aclIngestMonitor",
  aclIngestAssignToLabProvider = "aclIngestAssignToLabProvider",
  aclIngestRejectionsView = "aclIngestRejectionsView",
  aclIngestRejectionsBypass = "aclIngestRejectionsBypass",
  aclIngestRejectionsBypassOverwrite = "aclIngestRejectionsBypassOverwrite",
  aclIngestDeleteRequest = "aclIngestDeleteRequest",
  aclBackofficeUserListView = "aclBackofficeUserListView",
  aclBackofficeUserCreate = "aclBackofficeUserCreate",
  aclBackofficeUserDelete = "aclBackofficeUserDelete",
  aclBackofficeLabProviderCreate = "aclBackofficeLabProviderCreate",
  aclBackofficeWorkflowAdmin = "aclBackofficeWorkflowAdmin",
  aclBackofficeMailinglistView = "aclBackofficeMailinglistView",
  aclBackofficeMailinglistCreate = "aclBackofficeMailinglistCreate",
  aclBackofficeManualTasksCreate = "aclBackofficeManualTasksCreate",
  aclBackofficeManualTasksDelete = "aclBackofficeManualTasksDelete",
  aclBackofficeAuditLogsView = "aclBackofficeAuditLogsView",
  aclBackofficeTransferListView = "aclBackofficeTransferListView",
  aclSectionBackofficeAccess = "aclSectionBackofficeAccess",
  aclBackofficeUserLdapSync = "aclBackofficeUserLdapSync",
  aclWorkflowPurgeCreate = "aclWorkflowPurgeCreate",
  aclWorkflowPurgeCreateWithAcceptedAssetStatus = "aclWorkflowPurgeCreateWithAcceptedAssetStatus",
  aclWorkflowPurgeView = "aclWorkflowPurgeView",
  aclWorkflowQualifyCreate = "aclWorkflowQualifyCreate",
  aclWorkflowQualifyView = "aclWorkflowQualifyView",
  aclSectionSearchAccess = "aclSectionSearchAccess",
  aclSectionOrderAccess = "aclSectionOrderAccess",
  aclSectionReportingAccess = "aclSectionReportingAccess",
  aclSectionProjectManager = "aclSectionProjectManager",
  aclOrderStart = "aclOrderStart",
  aclOrderCancel = "aclOrderCancel",
  aclOrderIngestGenerated = "aclOrderIngestGenerated",
  aclRightsView = "aclRightsView",
  aclShareView = "aclShareView",
  aclShareCreate = "aclShareCreate",
  aclShareDelete = "aclShareDelete",
  aclShareUpdate = "aclShareUpdate",
  aclShareClipDelete = "aclShareClipDelete",
  aclShareClipImport = "aclShareClipImport",
  aclMetadataUpdate = "aclMetadataUpdate",
  aclMetadataUpdateWithAcceptedAssetStatus = "aclMetadataUpdateWithAcceptedAssetStatus",
  aclMetadataContentUpdate = "aclMetadataContentUpdate",
  aclMetadataTitleUpdate = "aclMetadataTitleUpdate",
  aclMetadataTitleDelete = "aclMetadataTitleDelete",
  aclMetadataAssetDisable = "aclMetadataAssetDisable",
  aclMetadataAssetViewDeleted = "aclMetadataAssetViewDeleted",
  aclMetadataMoveLinkContentUpdate = "aclMetadataMoveLinkContentUpdate",
  aclMetadataMoveLinkTitleUpdate = "aclMetadataMoveLinkTitleUpdate",
  aclOrderManualTaskView = "aclOrderManualTaskView",
  aclOrderQualityCheckCreate = "aclOrderQualityCheckCreate",
  aclOrderAssignBenefitCostLinkCreate = "aclOrderAssignBenefitCostLinkCreate",
  aclCustomersView = "aclCustomersView",
  aclCustomersCreate = "aclCustomersCreate",
  aclCustomersDelete = "aclCustomersDelete",
  aclViewStats = "aclViewStats",
  aclTitleCreate = "aclTitleCreate",
  aclFastModeShare = "aclFastModeShare",
  aclMediaFileUpload = "aclMediaFileUpload",
  aclMediaFileDownload = "aclMediaFileDownload",
  aclMediaFileDelete = "aclMediaFileDelete",
  aclRestrictedFileDownload = "aclRestrictedFileDownload",
  aclOrderUpdate = "aclOrderUpdate",
  aclOrderManageItemIssues = "aclOrderManageItemIssues",
  aclOrderAssignFollowers = "aclOrderAssignFollowers",
  aclOrderAssignPriority = "aclOrderAssignPriority",
  aclOrderOverrideItemPrice = "aclOrderOverrideItemPrice",
  aclOrderOverrideItemCustomer = "aclOrderOverrideItemCustomer",
  aclOrderPlayWithoutApproval = "aclOrderPlayWithoutApproval",
  aclAuditLogsView = "aclAuditLogsView",
  aclElevationWishlistCreate = "aclElevationWishlistCreate",
  aclElevationWishlistUpdate = "aclElevationWishlistUpdate",
  aclElevationWishlistDelete = "aclElevationWishlistDelete",
  aclClipCreate = "aclClipCreate",
  aclClipDelete = "aclClipDelete",
  aclScreenshotFrame = "aclScreenshotFrame",
  aclIngestConfigColumnSetCreate = "aclIngestConfigColumnSetCreate",
  aclIngestConfigColumnSetUpdate = "aclIngestConfigColumnSetUpdate",
  aclTitleUpdate = "aclTitleUpdate",
  aclMetadataExport = "aclMetadataExport",
  aclorderSendAckBillingManually = "aclorderSendAckBillingManually",
  aclPlatformDocumentsDownload = "aclPlatformDocumentsDownload",
  aclPlatformDocumentsUploadAndDelete = "aclPlatformDocumentsUploadAndDelete",
  aclOrderAttachFile = "aclOrderAttachFile",
  aclSupportTicketView = "aclSupportTicketView",
  aclSupportTicketCreate = "aclSupportTicketCreate",
  aclSupportTicketUpdate = "aclSupportTicketUpdate",
  aclSupportTicketComment = "aclSupportTicketComment",
  aclSupportTicketDelete = "aclSupportTicketDelete",
  aclSupportTicketBacklog = "aclSupportTicketBacklog",
  aclDeleteMetadataContentAssetsDeleted = "aclDeleteMetadataContentAssetsDeleted",
  aclMetadataContentViewDeleted = "aclMetadataContentViewDeleted",
  aclTitleRestrictedInfosView = "aclTitleRestrictedInfosView",
  aclDashboardTabOrders = "aclDashboardTabOrders",
  aclDashboardTabIngest = "aclDashboardTabIngest",
  aclDashboardTabTitles = "aclDashboardTabTitles",
  aclDashboardTabNotepad = "aclDashboardTabNotepad",
  aclOrderMaskNonAvailable = "aclOrderMaskNonAvailable",
  aclOrderDueDate = "aclOrderDueDate",
  aclOrderIsImportant = "aclOrderIsImportant",
  aclAssetQuickView = "aclAssetQuickView",
  aclAssetToolsView = "aclAssetToolsView",
  aclPlayerWatermarkLogin = "aclPlayerWatermarkLogin",
  aclOrderWatermarcking = "aclOrderWatermarcking",
  aclOrderAudioOnly = "aclOrderAudioOnly",
  aclDashboardTabRight = "aclDashboardTabRight",
  aclAssetDelete = "aclAssetDelete",
  aclAssetPdfExport = "aclAssetPdfExport",
  aclMarkerCreateOrUpdate = "aclMarkerCreateOrUpdate",
  aclMarkerDelete = "aclMarkerDelete",
  aclLoginEmulate = "aclLoginEmulate",
  aclUserTaskView = "aclUserTaskView",
  aclUserTaskUpdate = "aclUserTaskUpdate",
  aclMetadataTitleViewDeleted = "aclMetadataTitleViewDeleted",
  aclOrderEnableProductTranscodeAsMezz = "aclOrderEnableProductTranscodeAsMezz",
  aclSupportOnboardingView = "aclSupportOnboardingView",
  aclSwitchClassToRaw = "aclSwitchClassToRaw",
  aclSwitchClassToMezz = "aclSwitchClassToMezz",
  aclOrderApprove = "aclOrderApprove",
  aclTitleConfidentialitySet = "aclTitleConfidentialitySet",
  aclTitleConfidentialityPlay = "aclTitleConfidentialityPlay",
  aclTitleConfidentialityIngestRequestCreation = "aclTitleConfidentialityIngestRequestCreation",
  aclTitleConfidentialityOrders = "aclTitleConfidentialityOrders",
  aclTitleConfidentialityShares = "aclTitleConfidentialityShares",
  aclWorkflowView = "aclWorkflowView",
  aclExternalLinksView = "aclExternalLinksView",
  aclPlanningUserTaskView = "aclPlanningUserTaskView",
  aclPlanningUserTaskUpdate = "aclPlanningUserTaskUpdate",
  aclPlanningUserTaskAssign = "aclPlanningUserTaskAssign",
  aclFileUserDataAdd = "aclFileUserDataAdd",
  aclFileUserDataUpdate = "aclFileUserDataUpdate",
  aclFileUserDataDelete = "aclFileUserDataDelete",
  aclScriberAccess = "aclScriberAccess",
  aclAssetRestrictToFollower = "aclAssetRestrictToFollower",
  aclOrderRestrictToFollower = "aclOrderRestrictToFollower",
  aclJobRuleApply = "aclJobRuleApply",
  aclGroupCreate = "aclGroupCreate",
  aclOrderPriceRuleView = "aclOrderPriceRuleView",
  aclOrderPriceRuleCreate = "aclOrderPriceRuleCreate",
  aclOrderPriceRuleDelete = "aclOrderPriceRuleDelete",
  aclOrderPriceRuleMatchEnable = "aclOrderPriceRuleMatchEnable",
  aclSearchAdvancedEnable = "aclSearchAdvancedEnable",
  aclTimetool = "aclTimetool",
  aclConnectLinkTitle = "aclConnectLinkTitle",
  aclConnectImportTitle = "aclConnectImportTitle",
  aclIngestAssignPriority = "aclIngestAssignPriority",
  aclSyncTitleFromSpock = "aclSyncTitleFromSpock",
  aclOrderManualTask = "aclOrderManualTask",
  aclMakeTransferFileDownloadLink = "aclMakeTransferFileDownloadLink",
  aclAssetHideEmptyObjects = "aclAssetHideEmptyObjects",
  aclOrderWarnings = "aclOrderWarnings",
  aclBypassedAsset = "aclBypassedAsset",
  aclOrderContractAutoSelect = "aclOrderContractAutoSelect",
  aclOrderIngestLinkView = "aclOrderIngestLinkView",
  aclDisableAssetAccess = "aclDisableAssetAccess",
  aclBackofficeDeliveryProductUpdate = "aclBackofficeDeliveryProductUpdate",
  aclBackofficeDeliveryProductView = "aclBackofficeDeliveryProductView",
  aclSearchShowRecentTitles = "aclSearchShowRecentTitles",
  aclDocumentsAccess = "aclDocumentsAccess",
  aclWorkflowAssignFollowers = "aclWorkflowAssignFollowers",
  aclScribeProjectCreate = "aclScribeProjectCreate",
  aclSegmentCutView = "aclSegmentCutView",
  aclPermissionSet = "aclPermissionSet",
  aclPermissionDelete = "aclPermissionDelete",
  aclBackofficeQuotasView = "aclBackofficeQuotasView",
  aclPermissionView = "aclPermissionView",
  aclFileChangeUserDataStatusReady = "aclFileChangeUserDataStatusReady",
  aclScreenshotFrameHires = "aclScreenshotFrameHires",
  aclFileRestrictViewUploadOnlyMine = "aclFileRestrictViewUploadOnlyMine",
  aclMetricView = "aclMetricView",
  aclOrderManualTaskExternalChangeStatus = "aclOrderManualTaskExternalChangeStatus",
  aclFileSubtitleCheck = "aclFileSubtitleCheck",
  aclObjectTrashPut = "aclObjectTrashPut",
  aclObjectTrashView = "aclObjectTrashView",
  aclObjectTrashDelete = "aclObjectTrashDelete",
  aclIngestPlaceholderRemind = "aclIngestPlaceholderRemind",
  aclCopyObjectOverridingPlaceholderTemplate = "aclCopyObjectOverridingPlaceholderTemplate",
  aclCollectionStorefrontAdmin = "aclCollectionStorefrontAdmin",
  aclCollectionShareToGroup = "aclCollectionShareToGroup",
  aclCollectionShareToUser = "aclCollectionShareToUser",
  aclTransferExpire = "aclTransferExpire",
  aclGroupRoleManage = "aclGroupRoleManage",
  aclActivityAdd = "aclActivityAdd",
  aclLockAssetObjectAccess = "aclLockAssetObjectAccess",
  aclKdmUpload = "aclKdmUpload",
  aclKdmRecipientAdmin = "aclKdmRecipientAdmin",
  aclOrderQuoteView = "aclOrderQuoteView",
  aclOrderQuoteRequest = "aclOrderQuoteRequest",
  aclOrderQuoteValidate = "aclOrderQuoteValidate",
  aclTransferUpdate = "aclTransferUpdate",
  aclAssetBundlemaker = "aclAssetBundlemaker",
  aclBillingAccess = "aclBillingAccess",
  aclBillingAddExpense = "aclBillingAddExpense",
  aclBillingValidateInvoice = "aclBillingValidateInvoice",
  aclBillingChangePlan = "aclBillingChangePlan",
  aclBillingUnsubscribe = "aclBillingUnsubscribe",
  aclRestrictProviderTitlesToRequest = "aclRestrictProviderTitlesToRequest",
  aclRestrictProviderAssetsToRequest = "aclRestrictProviderAssetsToRequest",
  aclThumbnailClearCache = "aclThumbnailClearCache",
  aclBypassPermissions = "aclBypassPermissions",
  aclOrderSchedule = "aclOrderSchedule",
  aclThumbnailSetRef = "aclThumbnailSetRef",
  aclMetadataFieldPopulate = "aclMetadataFieldPopulate",
  aclImportMetadataBulk = "aclImportMetadataBulk",
  aclPlayTelestreamSwitch = "aclPlayTelestreamSwitch",
  aclObjectChangeStatus = "aclObjectChangeStatus",
  aclQuotaObjectView = "aclQuotaObjectView",
  aclDistributionDriveOnly = "aclDistributionDriveOnly",
  aclDrive = "aclDrive",
  aclMarkerBypassOrAskToFixIssue = "aclMarkerBypassOrAskToFixIssue",
  aclMarkerFixIssue = "aclMarkerFixIssue",
  aclMetadataAudioTracksUpdate = "aclMetadataAudioTracksUpdate",
  aclBundleTitleStatusChange = "aclBundleTitleStatusChange",
  aclBundleDashboardView = "aclBundleDashboardView",
  aclRestrictViewBundleOnly = "aclRestrictViewBundleOnly",
  aclExternalAccessCreateOrUpdate = "aclExternalAccessCreateOrUpdate",
  aclExternalAccessRevoke = "aclExternalAccessRevoke",
  aclExternalAccessView = "aclExternalAccessView",
  aclExternalAccessViewAll = "aclExternalAccessViewAll",
  aclTitleOverridePoster = "aclTitleOverridePoster",
  aclTitleOverrideCover = "aclTitleOverrideCover",
  aclOrderResendTransferEmail = "aclOrderResendTransferEmail",
  aclBackofficeYoutubeChannel = "aclBackofficeYoutubeChannel",
}
